import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestNoticeList = ({ csrfToken, pageNumber, postParams }) => {
  let getUrl = '/user/notice';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.post(
    getUrl,
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestNoticeDetail = ({ noticeId }) => {
  const result = apiClient.get(
    `/user/notice/detail/${noticeId}`,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestNoticeList,
  requestNoticeDetail,
};
